// extracted by mini-css-extract-plugin
export default {"icon":"TooltipTemplate_icon__Jk3bp","content":"TooltipTemplate_content__regQU"};